import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

function useAssets() {
  const { data, status } = useQuery({
    ...queries.user.assets(),
    retry: 1,
  });
  const isStamp = data?.rewardType === 'STAMP';
  const toast = useToast();
  useEffect(() => {
    if (status === 'error') {
      toast.error('자산 정보를 불러오지 못했습니다.\n잠시 후 다시 시도해주세요.');
    }
  }, [status]);
  return { isStamp, data };
}

export default useAssets;
